export default {
    API_URL: 'https://indigo-armsbk.anxilla.com',
    UNDER_MAINTENANCE : false,
    // API_URL: 'http://10.221.14.8:8000', 
    // API_URL: `http://${window.location.hostname}:8000`,
    //  API_URL : 'http://127.0.0.1:8000',  
}